(() => {
  const ROOT_SELECTOR = "[data-featured-product-root]";

  function sendAddToCart(variantId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to add item to cart");
        }

        return response.json();
      })
      .then(() => {
        if (window.location.pathname.includes("/cart")) {
          window.location.reload();
          return;
        }

        if (typeof getCartItems === "function") {
          getCartItems();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  function addFeaturedProductToCart(form) {
    const productId = form.querySelector('input[name="id"]');

    if (!productId || !productId.value) {
      console.error("No valid variant selected");
      return;
    }

    sendAddToCart(productId.value);
  }

  function getDropdown(card) {
    return card ? card.querySelector("[data-featured-product-dropdown]") : null;
  }

  function getToggleButton(card) {
    return card ? card.querySelector(".featuredProduct__btn") : null;
  }

  function closeDropdown(card) {
    const dropdown = getDropdown(card);
    if (!dropdown || dropdown.hidden) return;

    dropdown.hidden = true;

    const button = getToggleButton(card);
    if (button) button.setAttribute("aria-expanded", "false");

    const root = card.closest(ROOT_SELECTOR);
    if (
      root &&
      !root.querySelector("[data-featured-product-dropdown]:not([hidden])")
    ) {
      root.classList.remove("has-open-dropdown");
    }
  }

  function openDropdown(card) {
    const dropdown = getDropdown(card);
    if (!dropdown) return;

    const root = card.closest(ROOT_SELECTOR);
    if (root) {
      root
        .querySelectorAll(".featuredProduct--hasVariants")
        .forEach((otherCard) => {
          if (otherCard !== card) closeDropdown(otherCard);
        });
    }

    dropdown.hidden = false;

    const button = getToggleButton(card);
    if (button) button.setAttribute("aria-expanded", "true");

    if (root) root.classList.add("has-open-dropdown");
  }

  function toggleDropdown(card) {
    const dropdown = getDropdown(card);
    if (!dropdown) return;

    if (dropdown.hidden) {
      openDropdown(card);
    } else {
      closeDropdown(card);
    }
  }

  function bindForms(root) {
    root.querySelectorAll("[data-featured-product-form]").forEach((form) => {
      if (form.dataset.bound === "true") return;

      form.dataset.bound = "true";
      form.addEventListener("submit", (event) => {
        event.preventDefault();

        if (form.dataset.hasVariants === "true") {
          toggleDropdown(form.closest(".featuredProduct"));
          return;
        }

        addFeaturedProductToCart(form);
      });
    });
  }

  function bindDropdowns(root) {
    root.querySelectorAll("[data-featured-variant-id]").forEach((item) => {
      if (item.dataset.bound === "true") return;

      item.dataset.bound = "true";
      item.addEventListener("click", () => {
        const card = item.closest(".featuredProduct");
        closeDropdown(card);
        sendAddToCart(item.dataset.featuredVariantId);
      });
    });
  }

  let dropdownListenersBound = false;

  function bindGlobalDropdownListeners() {
    // No multi-variant featured products -> register no global listeners
    if (!document.querySelector("[data-featured-product-dropdown]")) return;

    if (dropdownListenersBound) return;
    dropdownListenersBound = true;

    // Capture phase: the dropdown is the topmost layer — a click/Escape that
    // closes it must not also close the cart drawer (Alpine handlers on the
    // overlay / @keyup.escape.window in header.liquid)
    document.addEventListener(
      "click",
      (event) => {
        const openDropdowns = document.querySelectorAll(
          "[data-featured-product-dropdown]:not([hidden])",
        );
        if (!openDropdowns.length) return;

        const clickedCard =
          event.target instanceof Element
            ? event.target.closest(".featuredProduct--hasVariants")
            : null;

        let closedAny = false;

        openDropdowns.forEach((dropdown) => {
          const card = dropdown.closest(".featuredProduct--hasVariants");
          // A click inside the card that owns the open dropdown (incl. the
          // button that just opened it) must not close it
          if (clickedCard === card) return;
          closeDropdown(card);
          closedAny = true;
        });

        // Clicking the drawer overlay closes only the dropdown, not the drawer
        if (
          closedAny &&
          event.target instanceof Element &&
          event.target.closest(".header__cart__overlay")
        ) {
          event.stopPropagation();
        }
      },
      true,
    );

    window.addEventListener(
      "keyup",
      (event) => {
        if (event.key !== "Escape") return;

        const openDropdowns = document.querySelectorAll(
          "[data-featured-product-dropdown]:not([hidden])",
        );
        if (!openDropdowns.length) return;

        // The drawer listens on @keyup.escape.window — while a dropdown is
        // open, Escape closes only the dropdown
        event.stopImmediatePropagation();

        openDropdowns.forEach((dropdown) => {
          const card = dropdown.closest(".featuredProduct--hasVariants");
          closeDropdown(card);

          const button = getToggleButton(card);
          if (button) button.focus();
        });
      },
      true,
    );
  }

  function initSwiperRoot(root) {
    if (!root || root.dataset.hasSwiper !== "true") return null;

    const swiperElement = root.querySelector(".featuredProductGroup__swiper");
    const paginationElement = root.querySelector(
      ".featuredProductGroup__pagination",
    );

    if (!swiperElement || !paginationElement) return null;

    if (root._featuredSwiper) {
      root._featuredSwiper.update();
      return root._featuredSwiper;
    }

    if (typeof Swiper === "undefined") return null;

    root._featuredSwiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 400,
      watchOverflow: true,
      resistanceRatio: 0.85,
      touchMoveStopPropagation: true,
      nested: root.classList.contains("featuredProductGroup--drawer"),
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      pagination: {
        el: paginationElement,
        clickable: true,
        type: "bullets",
      },
    });

    return root._featuredSwiper;
  }

  function initAllFeaturedProducts() {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      bindForms(root);
      bindDropdowns(root);
      initSwiperRoot(root);
    });

    bindGlobalDropdownListeners();
  }

  function runWhenSwiperReady() {
    if (typeof window.whenSwiperReady === "function") {
      window.whenSwiperReady(initAllFeaturedProducts);
      return;
    }

    if (typeof window.loadSwiper === "function") {
      window.loadSwiper().then(initAllFeaturedProducts);
      return;
    }

    window.setTimeout(runWhenSwiperReady, 100);
  }

  function refreshDrawerSwiper() {
    const drawer = document.querySelector(".header__cart");
    if (!drawer) return;

    const isVisible =
      drawer.offsetParent !== null &&
      window.getComputedStyle(drawer).display !== "none";

    if (!isVisible) return;

    const root = drawer.querySelector(
      '[data-featured-product-root][data-has-swiper="true"]',
    );

    if (!root) return;

    const refresh = () => initSwiperRoot(root);

    if (typeof Swiper === "undefined" && typeof window.loadSwiper === "function") {
      window.loadSwiper().then(refresh);
      return;
    }

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(refresh);
    });
  }

  function watchCartDrawer() {
    const drawer = document.querySelector(".header__cart");
    if (!drawer) return;

    const observer = new MutationObserver(refreshDrawerSwiper);
    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ["style", "class"],
    });
  }

  function start() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", runWhenSwiperReady, {
        once: true,
      });
    } else {
      runWhenSwiperReady();
    }

    watchCartDrawer();
  }

  start();
})();
